import { AppConstants } from "src/app/shared/constants/constants";
import { Component, inject, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-page-not-found",
  templateUrl: "./page-not-found.component.html",
  styleUrls: ["./page-not-found.component.scss"],
  standalone: true,
  imports: [TranslateModule],
})
export class PageNotFoundComponent implements OnInit {
  errorObject = {
    status: 404,
    mainHeading: "404",
    message: AppConstants.COMMON_ERROR_MSGS.PAGE_NOT_FOUND_MSG,
  };

  router = inject(Router);

  ngOnInit(): void {
    if (this.router.url === "/access-denied") {
      this.errorObject.mainHeading =
        AppConstants.COMMON_ERROR_MSGS.ACCESS_DENIED_MSG;
      this.errorObject.message =
        AppConstants.COMMON_ERROR_MSGS.ACCESS_DENIED_SUB_MSG;
      this.errorObject.status = 403;
    } else {
      this.errorObject.mainHeading = "404";
      this.errorObject.message =
        AppConstants.COMMON_ERROR_MSGS.PAGE_NOT_FOUND_MSG;
    }
  }
}
